import StackVertical from '../../Wrappers/StackVertical';
import Button from '../../Buttons/Button';
import { UploadFileDetailsType } from './UploadFileTypes';
import React, { memo, useEffect, useState } from 'react';
import { ColourMod, FlexAlign } from '../../../Data/Enums/LayoutEnums';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faTrash } from '@fortawesome/pro-solid-svg-icons';
import { GetReadableFileSize } from '../../../Constants/Helpers';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import StackHorizontal from '../../Wrappers/StackHorizontal';

const UploadFileEntry = memo((props: UploadFileDetailsType) => {
	const [showPreview, setShowPreview] = useState<boolean>(false);

	return (
		<>
			<div
				className={`upload-file-entry ${!props.valid ? ColourMod.Alert : ''} ${
					showPreview ? 'upload-preview-active' : ''
				}`}
				aria-label={`${props.file.name} File Entry`}
			>
				<StackHorizontal>
					<Button
						squared
						colour={showPreview ? ColourMod.Primary : ColourMod.Text}
						onClick={() => setShowPreview(!showPreview)}
						title={'Preview'}
						extraClass={'m-0'}
					>
						<FontAwesomeIcon icon={faEye} />
					</Button>
				</StackHorizontal>
				<StackVertical align={FlexAlign.Start}>
					<div className={'upload-file-entry-name'}>{props.file.name}</div>
					<span className={'upload-file-entry-size'}>{GetReadableFileSize(props.file.size)}</span>
				</StackVertical>
				<div className={'upload-file-entry-actions'}>
					<div className={`upload-file-entry-action upload-file-entry-valid`}>
						{props.valid && <FontAwesomeIcon icon={faCheck} />}
					</div>
				</div>
				<Button
					title={`Remove ${props.file.name}`}
					icon={<FontAwesomeIcon icon={faTrash} fixedWidth={true} />}
					iconOnly
					onClick={() => props.removeCallback()}
					extraClass={`upload-file-entry-action upload-file-entry-remove`}
					colour={ColourMod.Alert}
				/>
			</div>
			{showPreview && (
				<div className={`upload-file-preview`}>
					<embed src={URL.createObjectURL(props.file)} />
				</div>
			)}
		</>
	);
});

export { UploadFileEntry };
